import React from 'react';
import ServicePage from '../components/services/ServicePage';
import cafeBarriers from '../data/services/cafe-barriers';

const CafeBarriers: React.FC = () => <ServicePage data={cafeBarriers} />;

export default CafeBarriers;
